// Generated by Melange

import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Dropdowns from "../../components/molecules/Dropdowns.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../models/Kkm.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_components__CopyButton24 from "../../../../../packages/components/src/CopyButton24.js";
import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (kkm) {
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const initialFocusRef = React.useRef(null);
    const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match$1[1];
    const contextRoute = function (route) {
      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
    };
    const match$2 = React.useState(function () {
          return "";
        });
    const setName = match$2[1];
    const match$3 = React.useState(function () {
          return 1;
        });
    const setOfd = match$3[1];
    const match$4 = React.useState(function () {
          return "";
        });
    const setRegion = match$4[1];
    const region = match$4[0];
    const match$5 = React.useState(function () {
          return "";
        });
    const setCity = match$5[1];
    const city = match$5[0];
    const match$6 = React.useState(function () {
          return "";
        });
    const setStreet = match$6[1];
    const street = match$6[0];
    const match$7 = React.useState(function () {
          return "";
        });
    const setHouse = match$7[1];
    const house = match$7[0];
    const match$8 = React.useState(function () {
          return "";
        });
    const setApartment = match$8[1];
    const apartment = match$8[0];
    const match$9 = React.useState(function () {
          return 2024;
        });
    const setYear = match$9[1];
    const match$10 = React.useState(function () {
          return "Бухта 1.0";
        });
    const setModel = match$10[1];
    React.useEffect((function () {
            Curry._1(setName, (function (param) {
                    return kkm.name;
                  }));
            Curry._1(setStreet, (function (param) {
                    return kkm.address_street;
                  }));
            Curry._1(setHouse, (function (param) {
                    return kkm.address_street1;
                  }));
            Curry._1(setApartment, (function (param) {
                    return kkm.address_street2;
                  }));
          }), [kkm]);
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                      onSubmit: (function (param) {
                          
                        }),
                      initialFocusRef: initialFocusRef,
                      method_: "POST",
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                              label: "Название",
                              type_: "text",
                              name: "name",
                              size: "m",
                              required: true,
                              onChange: (function (value) {
                                  Curry._1(setName, (function (param) {
                                          return value;
                                        }));
                                }),
                              inputRef: initialFocusRef,
                              value: match$2[0]
                            }),
                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                              label: "Оператор ОФД",
                              type_: "text",
                              name: "ofd",
                              disabled: true,
                              size: "m",
                              required: true,
                              onChange: (function (value) {
                                  Curry._1(setOfd, (function (param) {
                                          return value;
                                        }));
                                }),
                              className: "mt-5",
                              inputClassName: "text-default-gray",
                              value: Buhta_cabinet__Kkm.Provider.toString(match$3[0])
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-asphalt mt-4",
                              children: "Адрес ККМ"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__Dropdowns.RegionSelect.make, {
                                    region: region,
                                    onRegionSelect: (function (value) {
                                        Curry._1(setRegion, (function (param) {
                                                return value;
                                              }));
                                        Curry._1(setCity, (function (param) {
                                                return "";
                                              }));
                                      })
                                  }),
                              className: "mt-4"
                            }),
                        region !== "" ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_cabinet__Dropdowns.CitySelect.make, {
                                      region: region,
                                      city: city,
                                      onCitySelect: (function (value) {
                                          Curry._1(setCity, (function (param) {
                                                  return value;
                                                }));
                                        })
                                    }),
                                className: "mt-5"
                              }) : null,
                        city !== "" ? JsxRuntime.jsxs(React.Fragment, {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Улица",
                                        type_: "text",
                                        name: "street",
                                        size: "m",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setStreet, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        className: "mt-5",
                                        value: street
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                label: "Дом",
                                                type_: "text",
                                                name: "house",
                                                size: "m",
                                                required: true,
                                                onChange: (function (value) {
                                                    Curry._1(setHouse, (function (param) {
                                                            return value;
                                                          }));
                                                  }),
                                                value: house
                                              }),
                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                label: "Квартира/Офис",
                                                type_: "text",
                                                name: "apartment",
                                                size: "m",
                                                onChange: (function (value) {
                                                    Curry._1(setApartment, (function (param) {
                                                            return value;
                                                          }));
                                                  }),
                                                value: apartment
                                              })
                                        ],
                                        className: "mt-5 flex justify-between gap-4"
                                      })
                                ]
                              }) : null,
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Buhta_cabinet__Dropdowns.KkmModelSelect.make, {
                                            model: match$10[0],
                                            onModelSelect: (function (value) {
                                                Curry._1(setModel, (function (param) {
                                                        return value;
                                                      }));
                                              })
                                          }),
                                      className: "grow"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Buhta_cabinet__Dropdowns.YearSelect.make, {
                                            year: match$9[0],
                                            onYearSelect: (function (value) {
                                                Curry._1(setYear, (function (param) {
                                                        return value;
                                                      }));
                                              })
                                          }),
                                      className: "grow"
                                    })
                              ],
                              className: "flex justify-between gap-4 mt-5"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "text-default-gray",
                                      children: kkm.serial_num
                                    }),
                                JsxRuntime.jsx(Buhta_components__CopyButton24.make, {
                                      text: kkm.serial_num
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                      className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                      children: "Серийный номер"
                                    })
                              ],
                              className: "rounded border border-gray-main px-4 py-[9px] mt-6 flex justify-between relative items-center"
                            }),
                        JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Зарегистрировать",
                              onClick: (function (param) {
                                  const form_address_street2 = apartment === "" ? undefined : apartment;
                                  const form = {
                                    administrative_area_code: region,
                                    locality_code: city,
                                    sublocality_code: undefined,
                                    kato: city,
                                    address_street: street,
                                    address_street1: house,
                                    address_street2: form_address_street2
                                  };
                                  const __x = Buhta_cabinet__Kassa.KkmManagerService.register(tenant, kkm.id, form);
                                  $$Promise.get(__x, (function (result) {
                                          if (result.TAG !== /* Ok */0) {
                                            return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы");
                                          }
                                          Buhta_cabinet__Route.navigateTo(contextRoute({
                                                    TAG: /* Kassa */2,
                                                    _0: /* Kkms */{
                                                      _0: /* List */1
                                                    }
                                                  }));
                                          Curry._1(dispatchToasts, {
                                                TAG: /* Add */0,
                                                _0: {
                                                  id: Buhta_core__Toast.generateId(undefined),
                                                  text: "ККМ успешно зарегистрирована",
                                                  kind: "success",
                                                  onClick: (function (param) {
                                                      
                                                    })
                                                }
                                              });
                                        }));
                                }),
                              className: "py-3 mt-6 w-full"
                            })
                      ]
                    }),
                className: "px-10 py-6"
              });
  };
}

function KkmRegisterPage$KkmStartForm(Props) {
  return make(Props.org)(Props.kkm);
}

const KkmStartForm = {
  make: KkmRegisterPage$KkmStartForm
};

function make$1(org) {
  return function (id) {
    return function (openMenu) {
      const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
      const deviceType = state.deviceType;
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const contextRoute = function (route) {
        return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
      };
      const func = Buhta_cabinet__Kassa.KkmManagerService.view;
      const match$1 = Buhta_core__GrpcState.useModel((function (param) {
              return Curry._3(func, param, /* [] */0, id);
            }), undefined);
      const dispatch = match$1[1];
      const kkmObj = match$1[0];
      React.useEffect((function () {
              Curry._2(dispatch, undefined, undefined);
            }), [id]);
      Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
              title: "Регистрация кассы",
              openMenu: openMenu
            }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
              title: "Регистрация кассы",
              route: contextRoute({
                    TAG: /* Kassa */2,
                    _0: /* Kkms */{
                      _0: /* List */1
                    }
                  })
            });
      return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                  header: header,
                  children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: typeof kkmObj === "string" ? (
                                        kkmObj === "Loading" ? JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}),
                                                className: "p-10"
                                              }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                                      ) : (
                                        kkmObj.NAME === "Data" ? JsxRuntime.jsx(KkmRegisterPage$KkmStartForm, {
                                                org: org,
                                                kkm: kkmObj.VAL
                                              }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                                      ),
                                    className: "bg-white w-full lg:w-[562px] border border-gray-main rounded-md shadow-kkms"
                                  }),
                              className: "p-10 lg:py-10 w-full lg:px-0 lg:flex lg:justify-center"
                            }),
                        className: "w-full flex flex-col items-center"
                      }),
                  className: "bg-gray-pale"
                });
    };
  };
}

function KkmRegisterPage(Props) {
  return Curry._1(make$1(Props.org)(Props.id), Props.openMenu);
}

const make$2 = KkmRegisterPage;

export {
  KkmStartForm ,
  make$2 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
